import React from "react";
import Divider from "@mui/material/Divider";
import CatalogSubHeading from "../CatalogSubHeading";
import { MyServicesCardHeader } from "../../MyServices/Cards/CardTemplate/myServicesCardHeader";
export const ProvisionSupersetHeader: React.FC = () => {
  return (
    <>
      <div className="catalogSuperset">
        <CatalogSubHeading
          title={"Provision Service"}
          style={{ padding: "0.625rem 0" }}
        />
        <div>
          <Divider />
        </div>
      </div>
      <MyServicesCardHeader
        imageSource={"/api/assets/superset.png"}
        title={"Apache Superset"}
        subTitle={`Ver. 1.0`}
        contents={
          "Apache Superset is an open-source data exploration and visualization platform that enables you to create interactive and shareable dashboards. Whether you're a data analyst, data scientist, or business user, Superset provides a user-friendly interface for exploring and visualizing your data."
        }
        tags={[
          {
            label: "BI",
            style: { backgroundColor: "#E7F3F9", color: "#0A85C7" },
          },
          {
            label: "Cross-Industry",
            style: { backgroundColor: "#EFE6FD", color: "#6200EE" },
          },
          {
            label: "Data & Analytics",
            style: { backgroundColor: "#FFE5F0", color: "#D72F77" },
          },
        ]}
      ></MyServicesCardHeader>
    </>
  );
};
